import React, { useEffect, useState } from "react";
import "./menu.css";
import { Link } from "react-router-dom";
import { options } from "./option";
import axios from "axios";

export default function Menu() {
  const find = [
    { id: 1, msg: "查IP" },
    { id: 2, msg: "地图" },
    { id: 3, msg: "火车票" },
    { id: 4, msg: "疫情防控" },
    { id: 5, msg: "违章限号" },
    { id: 6, msg: "网盘" },
    { id: 7, msg: "邮箱" },
    { id: 8, msg: "汇率" },
    { id: 9, msg: "查快递" },
    { id: 10, msg: "股票行情" },
    { id: 11, msg: "个税查询" },
    { id: 12, msg: "翻译" },
  ];

  // 控制选项栏状态
  const [cut, setCut] = useState(false);
  useEffect(() => {}, [cut]);

  // 默认城市数据
  useEffect(() => {}, []);

  // 默认省份数据
  const [provice, setProvice] = useState({
    provice: "北京",
    city: [
      {
        cityname: "北京",
        code: "101010100",
      },
      {
        cityname: "朝阳",
        code: "101010300",
      },
      {
        cityname: "顺义",
        code: "101010400",
      },
      {
        cityname: "怀柔",
        code: "101010500",
      },
      {
        cityname: "通州",
        code: "101010600",
      },
      {
        cityname: "昌平",
        code: "101010700",
      },
      {
        cityname: "延庆",
        code: "101010800",
      },
      {
        cityname: "丰台",
        code: "101010900",
      },
      {
        cityname: "石景山",
        code: "101011000",
      },
      {
        cityname: "大兴",
        code: "101011100",
      },
      {
        cityname: "房山",
        code: "101011200",
      },
      {
        cityname: "密云",
        code: "101011300",
      },
      {
        cityname: "门头沟",
        code: "101011400",
      },
      {
        cityname: "平谷",
        code: "101011500",
      },
      {
        cityname: "八达岭",
        code: "101011600",
      },
      {
        cityname: "佛爷顶",
        code: "101011700",
      },
      {
        cityname: "海淀",
        code: "101010200",
      },
    ],
  });

  // 默认城市数据

  // 选中的省份
  const handleProvice = (event) => {
    // eslint-disable-next-line no-lone-blocks
    {
      // eslint-disable-next-line array-callback-return
      options.map((todo) => {
        if (todo.provice === event.target.value) {
          setProvice(todo);
        }
      });
    }
  };

  const [area, setArea] = useState("北京");
  const [areas, setAreas] = useState("北京");
  const [code, setCode] = useState(0);
  const [codes, setCodes] = useState(101010100);
  // 选中的城市
  const handleCity = (event) => {
    setArea(event.target.value);
    // eslint-disable-next-line no-lone-blocks
    {
      // eslint-disable-next-line array-callback-return
      provice.city.map((todos) => {
        if (todos.cityname === event.target.value) {
          setCode(todos.code);
        }
      });
    }
  };

  const [weather, setWeather] = useState([
    {
      cloud: "25",
      fxDate: "2023-07-25",
      humidity: "78",
      iconDay: "101",
      iconNight: "302",
      moonPhase: "峨眉月",
      moonPhaseIcon: "801",
      moonrise: "12:05",
      moonset: "23:15",
      precip: "0.0",
      pressure: "1003",
      sunrise: "05:05",
      sunset: "19:38",
      tempMax: "33",
      tempMin: "24",
      textDay: "多云",
      textNight: "雷阵雨",
      uvIndex: "2",
      vis: "22",
      wind360Day: "0",
      wind360Night: "0",
      windDirDay: "北风",
      windDirNight: "北风",
      windScaleDay: "1-2",
      windScaleNight: "1-2",
      windSpeedDay: "3",
      windSpeedNight: "3",
    },
    {
      cloud: "25",
      fxDate: "2023-07-25",
      humidity: "78",
      iconDay: "101",
      iconNight: "302",
      moonPhase: "峨眉月",
      moonPhaseIcon: "801",
      moonrise: "12:05",
      moonset: "23:15",
      precip: "0.0",
      pressure: "1003",
      sunrise: "05:05",
      sunset: "19:38",
      tempMax: "33",
      tempMin: "24",
      textDay: "多云",
      textNight: "雷阵雨",
      uvIndex: "2",
      vis: "22",
      wind360Day: "0",
      wind360Night: "0",
      windDirDay: "北风",
      windDirNight: "北风",
      windScaleDay: "1-2",
      windScaleNight: "1-2",
      windSpeedDay: "3",
      windSpeedNight: "3",
    },
  ]);

  // 监听省份
  useEffect(() => {}, [provice, area, codes, weather]);

  useEffect(() => {
    axios
      .get(
        `https://devapi.qweather.com/v7/weather/3d?location=${codes}&key=76b0c98d2cde43699aa2460d9a6da924`
      )
      .then((response) => {
        setWeather(response.data.daily);
      });
  }, [codes]);

  const [mon, setMon] = useState(1);
  const [date, setDate] = useState(1);
  useEffect(() => {
    let myDate = new Date();
    let mon = myDate.getMonth() + 1;
    let date = myDate.getDate();
    setMon(mon);
    setDate(date);
  }, []);

  return (
    // 导航页面
    <div className="menu">
      {/* logo */}
      <div className="menu-first">
        <Link to="http://itemvs.com/">
          <img src={require("./img/logo.png")} alt="" className="logo" />
        </Link>
      </div>
      {/* 地址 */}
      {cut === false && (
        <div className="menu-first">
          <div className="site">
            <div className="site-box">
              <span>{areas}</span>
            </div>
            <span
              className="site-cut"
              onClick={() => {
                setCut(true);
              }}
            >
              切换
            </span>
            <div className="site-bottom ">
              <span>七日天气</span>
            </div>
          </div>
        </div>
      )}

      {/* 切换栏 */}
      {cut === true && (
        <div className="menu-first">
          <div className="cut-box">
            <div className="cut-box-title">
              <span>切换城市</span>&nbsp;&nbsp;
              <span
                onClick={() => {
                  setCut(false);
                }}
                className="cut-box-cancel"
              >
                取消
              </span>
            </div>
            <div className="cut-box-area">
              {/* 省份 */}
              <select className="cut-box-select" onChange={handleProvice}>
                {options.map((option) => {
                  return (
                    <option value={option.provice} key={option.provice}>
                      {option.provice}
                    </option>
                  );
                })}
              </select>
              {/* 城市 */}
              <select className="cut-box-select" onChange={handleCity}>
                <option value="">请选择城市</option>
                {provice.city.map((city) => {
                  return (
                    <option value={city.cityname} key={city.cityname}>
                      {city.cityname}
                    </option>
                  );
                })}
              </select>
            </div>
            <div
              className="cut-box-confirm"
              onClick={() => {
                setCut(false);
                setAreas(area);
                setCodes(code);
                axios
                  .get(
                    `https://devapi.qweather.com/v7/weather/3d?location=${codes}&key=76b0c98d2cde43699aa2460d9a6da924`
                  )
                  .then((response) => {
                    console.log(response);
                  });
              }}
            >
              <span>确定</span>
            </div>
          </div>
        </div>
      )}

      {/* 天气预报 */}
      <div className="menu-first">
        <div className="weather-site">
          <img src={require("./img/weather.png")} alt="" className="weather" />
          <span>
            今&nbsp;&nbsp;{weather[0].textDay}&nbsp;&nbsp;{weather[0].tempMin}~
            {weather[0].tempMax}℃
          </span>
        </div>
        <div className="weather-site">
          <img src={require("./img/weather.png")} alt="" className="weather" />
          <span>
            明&nbsp;&nbsp;{weather[1].textDay}&nbsp;&nbsp;{weather[1].tempMin}~
            {weather[1].tempMax}℃
          </span>
        </div>
      </div>
      {/* 日期 */}
      <div className="menu-first">
        <div className="data">
          <span
            onClick={() => {
              window.open(
                "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E6%97%A5%E5%8E%86"
              );
            }}
          >
            {mon}月{date}日
          </span>
          &nbsp;&nbsp;
        </div>
        <div className="data">
          <span
            onClick={() => {
              window.open(
                "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E6%98%9F%E5%BA%A7%E8%BF%90%E5%8A%BF"
              );
            }}
          >
            星座运势
          </span>
        </div>
      </div>
      {/* 查IP */}
      <div className="menu-next">
        <ul className="findfather">
          {find.map((item) => {
            return (
              <li className="findIP" key={item.id}>
                <span
                  onClick={() => {
                    if (item.id === 1) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=IP%E6%9F%A5%E8%AF%A2"
                      );
                    }
                    if (item.id === 2) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E7%99%BE%E5%BA%A6%E5%9C%B0%E5%9B%BE"
                      );
                    }
                    if (item.id === 3) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E7%81%AB%E8%BD%A6%E7%A5%A8"
                      );
                    }
                    if (item.id === 4) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E8%AE%A1%E7%AE%97%E5%99%A8"
                      );
                    }
                    if (item.id === 5) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E7%94%B5%E7%99%BD%E9%99%90%E8%A1%8C"
                      );
                    }
                    if (item.id === 6) {
                      window.open("https://pan.baidu.com/");
                    }
                    if (item.id === 7) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E9%82%AE%E7%AE%B1%E5%AF%BC%E8%88%AA"
                      );
                    }
                    if (item.id === 8) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E6%B1%87%E7%8E%87"
                      );
                    }
                    if (item.id === 9) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E6%9F%A5%E8%AF%A2%E5%BF%AB%E9%80%92"
                      );
                    }
                    if (item.id === 10) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E6%8C%87%E6%95%B0%E8%A1%8C%E6%83%85"
                      );
                    }
                    if (item.id === 11) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E4%B8%AA%E7%A8%8E%E6%9F%A5%E8%AF%A2"
                      );
                    }
                    if (item.id === 12) {
                      window.open(
                        "https://www.baidu.com/s?tn=02003390_42_hao_pg&ie=utf-8&word=%E7%BF%BB%E8%AF%91"
                      );
                    }
                  }}
                >
                  {item.msg}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
      {/* 登录 */}
    </div>
  );
}
